import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

import applyModuleThemeColor from "~/pwa/applyModuleThemeColor";
import { findAppForPath, resolveInitialApp } from "~/pwa/installableApps";

applyModuleThemeColor(resolveInitialApp());

const useModuleThemeColor = (): void => {
	const { pathname } = useLocation();
	useLayoutEffect(() => {
		applyModuleThemeColor(findAppForPath(pathname));
	}, [pathname]);
};

export default useModuleThemeColor;
